import React, { useEffect, useState, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useParams } from 'react-router-dom'
import poServices from '../poServices';
import { useAlert } from '../../../../../context/AlertContext';
import { Print } from '@mui/icons-material';
import { useAppData } from '../../../../../context/AppDataContext';
import { useAuth } from '../../../../../context/AuthContext';
import POForm from '../components/POForm';
import POTransactions from '../components/POTransactions';


export default function PODetailsPage() {
  const{AppAlert} = useAlert();
  const {authUser } = useAuth();
  const {getMasterLabel} = useAppData();
  const {id} = useParams();
  const [loading,setLoadingStatus] = useState(null);
  const [poDetails,setPoDetails] = useState(null);

  const getPODetails = () =>{
    poServices.getDetailsById(id).then(res=>{
      setLoadingStatus(true);
      setPoDetails(res.data);
    }).catch(error=>{
      AppAlert(error.msg,"error")
    }).finally(()=>{
      setLoadingStatus(false);
    })
  }

  useEffect(()=>{
    getPODetails();
  },[id])



  const printComponentRef = useRef();

  const handlePrint = useReactToPrint({
      content: () => printComponentRef.current,
      //pageStyle:"@page { size: 2.5in 2.5in; margin: 0; padding:0 }, @media print { @page {  size: 2.5in 2.5in margin: 0mm !important;  body,html{padding:0px;margin:0px;} } }",
      //pageStyle:"@media print { html, body { height: 2.5in; /* Use 100% here to support printing more than a single page*/ margin: 0 !important;padding: 0 !important;overflow: hidden;}}; @page { size: 2.5in 2.5in; margin: 0; }"
      //onAfterPrint:()=>{navigate("/kiosk/dashboard")}
    });

  return (
    <ErpLayout>
      <div className='row mb-3'>
        <div className='col-md-12'>
          <span className='float-end me-2'>
            {poDetails && <POForm  callBack={getPODetails} data={poDetails} /> }
          </span>
          <button className='btn btn-outline-primary float-end' onClick={handlePrint}><Print/> Print</button>
        </div>
      </div>
      {poDetails &&
        <div className='row mb-3'>
          <div className='col-md-12'><POTransactions poId={poDetails.id} /></div>
        </div>
      }
      {poDetails &&
      <div className='row ' >
          <div className='card' >
            <div className='card-body' ref={printComponentRef}>
                <div className='row'>
                  <div className="col-md-12 text-center">
                      <h5 className='fw-bold text-primary'>WORK ORDER</h5>
                  </div>
                  <hr/>
                  <div className='col-4'>
                    <img style={{maxWidth:"2in", height:"auto"}} src={poDetails.company_details.logo}/>
                    <div style={{fontSize:12}}>Phone : {poDetails.company_details.phone}</div>
                    <div style={{fontSize:12}}>Email : {poDetails.company_details.email}</div>
                  </div>
                  <div className='col-4 text-center'>
                    <h5 className='fw-bold'>{poDetails.company_details.companyName}</h5>
                    <div><span className='fw-bold'>GST No : </span>{poDetails.company_details.gst}</div>
                  </div>
                  <div className='col-4'>
                    <table className='table table-striped ' style={{pageBreakAfter:"avoid"}}>
                      <tbody>
                        <tr>
                          <th>Order No</th>
                          <td>{poDetails.poNo}</td>
                        </tr>
                        <tr>
                          <th>Order Date</th>
                          <td>{poDetails.orderDate}</td>
                        </tr>
                      </tbody>  
                    </table>
                    
                  </div>
                </div>

                <div className='row'>
                  <div className='col-6'>
                    <div className='card'>
                      <div className='card-header fw-bold'>From</div>
                      <div className='card-body'>
                        <div className='fw-bold'>{poDetails.company_details.companyName}</div>
                        <div><span className='fw-bold'>GST No : </span>{poDetails.company_details.gst}</div>
                        <div>{poDetails.company_details.address}, {poDetails.company_details.city}, {poDetails.company_details.state}, {poDetails.company_details.zip}</div>
                        
                      </div>
                    </div>
                  </div>

                  <div className='col-6'>
                    <div className='card'>
                      <div className='card-header fw-bold'>TO</div>
                      <div className='card-body'>
                        <div className='fw-bold'>{poDetails.vendor_details.vendorName}</div>
                        <div><span className='fw-bold'>GST No : </span>{poDetails.vendor_details.gst}</div>
                        <div>{poDetails.vendor_details.address}, {poDetails.vendor_details.city}, {poDetails.vendor_details.state},{poDetails.vendor_details.zip}</div>
                        
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mt-3'>
                  
                  <div className='col-12'>
                    <table className='table table-bordered' style={{pageBreakAfter:"avoid"}}>
                      <thead>
                        <tr className='table-primary'>
                          <th>Item Description </th>
                          <th>UOM</th>
                          <th>Quantity</th>
                          <th>Price Per Unit</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div><span className='fw-bold'>Product Name : </span> {poDetails.product_details.title}</div>
                            <div><span className='fw-bold'>Product Description </span>{poDetails.product_details.details}</div>
                          </td>
                          <td>{ getMasterLabel("product-uom",poDetails.product_details.uom)}</td>
                          <td>{poDetails.qty}</td>
                          <td>{poDetails.price}</td>
                          <th>{poDetails.price * poDetails.qty}</th>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={3}></td>
                          <th>GST @ {poDetails.gstRate}</th>
                          <th>{(poDetails.price * poDetails.qty * poDetails.gstRate) / 100}</th>
                        </tr>
                        <tr>
                          <td colSpan={3}></td>
                          <th>Grand Total</th>
                          <th>{(poDetails.price * poDetails.qty) + (poDetails.price * poDetails.qty* poDetails.gstRate) / 100}</th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-6'>
                    <div className='card mb-2'>
                      <div className='card-header'>Reference</div>
                      <div className='card-body'>{poDetails.refDetails}</div>
                    </div>
                  </div>
                
                  <div className='col-6'>
                    <div className='card mb-2'>
                      <div className='card-header'>Delevery Location</div>
                      <div className='card-body'>
                        <div className='fw-bold'>{poDetails.project_location.title}</div>
                        <p>{poDetails.project_location.address},{poDetails.project_location.city}, {poDetails.project_location.state}, {poDetails.project_location.zip}</p>
                      </div>
                    </div>                    
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-12'>
                    <div className='card mb-2'>
                      <div className='card-header'>Terms & Conditions</div>
                      <div className='card-body' style={{ whiteSpace: 'pre-wrap' }}>{poDetails.poTerms}</div>
                    </div>
                  </div>
                </div>

                
                <div className='row mt-2'>
                  <div className='col-8'></div>
                  <div className='col-4 text-center'>
                    <div><img  style={{maxWidth:"1in", height:"auto"}} src={poDetails.company_details.authSign}/></div>
                    <div className='fw-bold'>Authorized Signatory</div>
                    <div className='fw-bold'>{authUser.firstName} {authUser.lastName}</div>
                  </div>

                </div>

            </div>
          </div>
          <div className='col-md-12'>
          </div>
      </div>
      }
    </ErpLayout>
  )
}
